export const v0Properties = [
  "name",
  "email",
  "phone",
  "teams",
  "length_capacity(cm)",
  "height_capacity(cm)",
  "width_capacity(cm)",
  "weight_capacity(kg)",
  "vehicle",
  "maxStopsPerRoute",
  "maxRouteDistance(km)",
  "maxRouteDuration",
]
